import { useContext, useEffect } from "react";
import { PlayerContext } from "PlayerContext";

const useOnSpeechEvents = ({ onSpeechStart }: { onSpeechStart: () => any }) => {
  const { setOnSpeechStart } = useContext(PlayerContext);

  useEffect(() => {
    setOnSpeechStart(() => onSpeechStart);

    return () => {
      setOnSpeechStart(() => {});
    };
  }, [setOnSpeechStart, onSpeechStart]);
};

export default useOnSpeechEvents;
